import { rumBeforeSend } from '@/lib/observability/rumEventFilter';
import { datadogRum } from '@datadog/browser-rum';
import { nextjsPlugin } from '@datadog/browser-rum-nextjs';

// applicationId e clientToken do RUM sao identificadores publicos: vao para o bundle do browser
// e sao legiveis por qualquer visitante no DevTools. Ficam embutidos porque tratar como segredo
// nao protege nada e transforma uma env var faltando no build em silencio total — a instrumentacao
// simplesmente nao inicializa, sem erro. As env vars seguem valendo para apontar outra aplicacao.
const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || 'd2597e0c-dc0c-4ec7-9c65-518e5db1405c';
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || 'pub9e3ea20ebcdb967f4e7672030770d110';

// O rewrite de next.config.mjs serve a API em /api/v1 na mesma origem, mas parte do
// código chama NEXT_PUBLIC_API_BASE_PATH direto. Os dois caminhos precisam propagar trace.
const apiBasePath = process.env.NEXT_PUBLIC_API_BASE_PATH;

// Com os identificadores embutidos, qualquer `next dev` — de dev ou do E2E no CI — publicaria na mesma
// aplicacao de producao. So build do Amplify reporta; o E2E ainda desliga explicitamente, porque um
// .env local com NEXT_PUBLIC_APP_ENV=production faria o deployEnv deixar de ser 'local'.
const deployEnv = process.env.NEXT_PUBLIC_DEPLOY_ENV || 'local';
const rumEnabled = deployEnv !== 'local' && process.env.NEXT_PUBLIC_DATADOG_RUM_DISABLED !== 'true';

if (rumEnabled && applicationId && clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE || 'datadoghq.com',
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE || 'masp-tickets-web',
    env: deployEnv,
    version: process.env.NEXT_PUBLIC_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    // O checkout tem campo de cartão; mascarar input é o que impede o replay de gravar PAN e CVV.
    defaultPrivacyLevel: 'mask-user-input',
    // Descarta erro de script de terceiro que não conseguimos corrigir (hoje, o rdtracker do RD Station).
    beforeSend: rumBeforeSend,
    allowedTracingUrls: [
      {
        match: (url: string) =>
          url.startsWith(`${window.location.origin}/api/v1`) || Boolean(apiBasePath && url.startsWith(apiBasePath)),
        // A API só libera traceparent/tracestate no CORS do HTTP API; x-datadog-* seria bloqueado no preflight.
        propagatorTypes: ['tracecontext'],
      },
    ],
    plugins: [nextjsPlugin()],
  });
}

export { onRouterTransitionStart } from '@datadog/browser-rum-nextjs';
